import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_CREATE_MESSAGE_USER_ID_LIST_MUTATION = graphql(`
  mutation EditMessageThreadCreateMessageUserIdList(
    $id: ID!
    $createMessageUserIdList: [ID!]!
  ) {
    editMessageThread(
      id: $id
      input: { createMessageUserIdList: $createMessageUserIdList }
    ) {
      id
      createMessageUserIdList
    }
  }
`);

export default EDIT_MESSAGE_THREAD_CREATE_MESSAGE_USER_ID_LIST_MUTATION;
